"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAsyncActions = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _reactRedux = require("react-redux");

var _asyncHelpers = require("./asyncHelpers");

var _ramdaAdditions = require("./utils/ramdaAdditions");

var _withAsyncHandlers = require("./withAsyncHandlers");

var _redux = require("redux");

var defaultOptions = {
  connectData: true,
  connectMeta: true,
  resetOnMount: false,
  resetOnUpdate: false,
  resetOnUnmount: false,
  dispatchOnMount: false,
  dispatchOnUpdate: false
};

var defaultShouldUpdate = function defaultShouldUpdate(props, nextProps, action) {
  if (!action.defaultPayload) {
    return false;
  }

  return !(0, _ramda.equals)(action.defaultPayload(props), action.defaultPayload(nextProps));
};

var renameDeprecatedKeys = (0, _ramdaAdditions.renameKeys)({
  autoFetch: 'dispatchOnMount',
  autoUpdate: 'dispatchOnUpdate',
  autoReset: 'resetOnUnmount'
});

var withAsyncActions = function withAsyncActions(actionsConfig) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mapStateToProps = arguments.length > 2 ? arguments[2] : undefined;
  var mapDispatchToProps = arguments.length > 3 ? arguments[3] : undefined;
  options = (0, _ramda.merge)(defaultOptions, renameDeprecatedKeys(options));

  var getOptions = function getOptions(action, props) {
    return (0, _ramda.merge)(options, renameDeprecatedKeys((0, _asyncHelpers.callWithProps)(action.options, props)));
  };

  return function (WrappedComponent) {
    var intervals = [];

    var hoc =
    /*#__PURE__*/
    function (_Component) {
      (0, _inherits2["default"])(hoc, _Component);

      function hoc() {
        (0, _classCallCheck2["default"])(this, hoc);
        return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(hoc).apply(this, arguments));
      }

      (0, _createClass2["default"])(hoc, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this = this;

          var actions = (0, _asyncHelpers.getActions)(this.props, actionsConfig);
          (0, _ramda.forEachObjIndexed)(function (action, key) {
            (0, _ramda.when)((0, _ramda.prop)('dispatchOnMount'), function (options) {
              var getPayload = action.defaultPayload;

              _this.props[key].dispatch(getPayload && getPayload(_this.props));

              (0, _ramda.when)((0, _ramda.prop)('pollInterval'), function () {
                intervals.push(setInterval(function () {
                  _this.props[key].dispatch(getPayload && getPayload(_this.props));
                }, options.pollInterval));
              })(options);
            })(getOptions(action, _this.props));
            (0, _ramda.when)((0, _ramda.prop)('resetOnMount'), function () {
              _this.props[key].reset();
            })(getOptions(action, _this.props));
          }, actions);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this2 = this;

          (0, _ramda.forEachObjIndexed)(function (action, key) {
            return (0, _ramda.when)((0, _ramda.prop)('dispatchOnUpdate'), function (options) {
              var shouldUpdate = action.shouldUpdate || defaultShouldUpdate;

              if (shouldUpdate(prevProps, _this2.props, action)) {
                (0, _ramda.when)((0, _ramda.prop)('resetOnUpdate'), prevProps[key].reset)(options);
                var getPayload = action.defaultPayload;

                _this2.props[key].dispatch(getPayload && getPayload(_this2.props));
              }
            })(getOptions(action, _this2.props));
          }, (0, _asyncHelpers.getActions)(this.props, actionsConfig));
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var _this3 = this;

          (0, _ramda.forEachObjIndexed)(function (action, key) {
            return (0, _ramda.when)((0, _ramda.prop)('resetOnUnmount'), _this3.props[key].reset)(getOptions(action, _this3.props));
          }, (0, _asyncHelpers.getActions)(this.props, actionsConfig));
          (0, _ramda.forEach)(clearInterval, intervals);
        }
      }, {
        key: "render",
        value: function render() {
          return _react["default"].createElement(WrappedComponent, this.props);
        }
      }]);
      return hoc;
    }(_react.Component);

    var stateToProps = function stateToProps(state, props) {
      var items = [];
      (0, _ramda.forEachObjIndexed)(function (action, actionName) {
        var actionOptions = (0, _ramda.merge)(options, action.options || {});

        if (actionOptions.connectData) {
          items.push([actionName + '_data', (0, _asyncHelpers.getActionData)(action, state, props)]);
        }

        if (actionOptions.connectMeta) {
          items.push([actionName + '_meta', (0, _asyncHelpers.getActionMeta)(action, state, props)]);
        }
      }, (0, _asyncHelpers.getActions)(props, actionsConfig));

      if (mapStateToProps) {
        return (0, _objectSpread2["default"])({}, (0, _ramda.fromPairs)(items), mapStateToProps(state, props));
      } else {
        return (0, _ramda.fromPairs)(items);
      }
    };

    var dispatchToProps = function dispatchToProps(dispatch, props) {
      var actions = (0, _ramda.map)(function (action) {
        var params = (0, _asyncHelpers.callWithProps)(action.params, props);
        var assocParams = (0, _ramda.assoc)('params', params);

        var composeAction = function composeAction(action) {
          return (0, _ramda.compose)(dispatch, assocParams, action);
        };

        var dispatchAction = composeAction(action);
        var defaultPayload = action.defaultPayload && action.defaultPayload(props);
        return {
          refresh: function refresh(payload) {
            return dispatchAction(payload || defaultPayload);
          },
          dispatch: dispatchAction,
          request: composeAction(action.request),
          success: composeAction(action.success),
          error: composeAction(action.error),
          reset: composeAction(action.reset),
          load: composeAction(action.load)
        };
      }, (0, _asyncHelpers.getActions)(props, actionsConfig));
      var connectDispatch = (0, _ramda.is)(Object, mapDispatchToProps) ? (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch) : mapDispatchToProps && mapDispatchToProps(dispatch, props);
      return (0, _ramda.merge)(actions, {
        __connect: connectDispatch
      });
    };

    var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
      var stateToProps = stateProps;
      return (0, _objectSpread2["default"])({}, ownProps, (0, _ramda.mapObjIndexed)(function (action, key) {
        stateToProps = (0, _ramda.omit)([key + '_data', key + '_meta'], stateToProps);
        return (0, _objectSpread2["default"])({
          type: action.type,
          data: stateProps[key + '_data'],
          meta: stateProps[key + '_meta']
        }, dispatchProps[key]);
      }, (0, _asyncHelpers.getActions)(ownProps, actionsConfig)), stateToProps, dispatchProps.__connect);
    };

    return (0, _reactRedux.connect)(stateToProps, dispatchToProps, mergeProps)((0, _withAsyncHandlers.withAsyncHandlers)(actionsConfig)(hoc));
  };
};

exports.withAsyncActions = withAsyncActions;